export function initTokenisingField({ placeholder, fieldType, name, autocomplete, validateAs, // e.g. "cc", "cvv"
iframeElement, style, clientId, pciFrameUrl, }) {
    if (iframeElement && iframeElement.contentWindow) {
        // Initialise iframe
        iframeElement.contentWindow.postMessage(JSON.stringify({
            style,
            type: 'init',
            name,
            autocomplete,
            fieldType,
            validateAs,
            placeholder,
            clientId,
            // In default mode a token is sent via postMessage as soon as the field contains a valid credit card number
            // In 'manual' mode a token is sent in response to this, the expiry parameter is optional:
            // Its advisable to include the clientId if multiple tokenising fields are included
            // `postMessage({ type: 'gettoken', expiry: new Date(cardExpiryYear, cardExpiryMonth).toISOString(), clientId })`
            manual: false,
        }), pciFrameUrl);
    }
}
